module.exports = __webpack_public_path__ + "static/img/details-01.e1692d9e.webp";